import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentStatGrid } from 'declarations/contentful';

import Container from './shared/Container';

interface StatGridItemsProps {
  items: NonNullable<ILpComponentStatGrid['fields']['items']>;
}

const StatGridItems = ({ items }: StatGridItemsProps) => {
  return (
    <>
      {items.map((stat, i) => (
        <Col key={stat.sys?.id ?? i} className="min-w-20 gap-1.5 md:grow md:basis-[46%] lg:basis-0">
          <Text
            as="p"
            className="block text-display-sm font-medium text-od-content-primary max-md:text-header-md"
          >
            {stat.fields.value}
          </Text>
          <Text as="p" className="block text-body-md text-od-content-tertiary">
            {stat.fields.description}
          </Text>
        </Col>
      ))}
    </>
  );
};

const renderStatGrid = (entry: ILpComponentStatGrid) => {
  const { items } = entry.fields;
  if (!items?.length) return null;

  return (
    <Container noSectionSpacing paddingVertical="$16x">
      <Col className="gap-6 md:flex-row md:flex-wrap">
        <StatGridItems items={items} />
      </Col>
    </Container>
  );
};

const StatGrid: EntryComponent<ILpComponentStatGrid> = {
  render: renderStatGrid,
};

export default StatGrid;
